import { openRamsSigningModal } from '../State/ramsSigningModal'

export default () => (dispatch) => {

  dispatch(openRamsSigningModal())

}
